<template>
    <div style="overflow-y: auto; overflow-x: hidden"  v-ripple>

        <div
                class="d-flex align-center pl-1 hide-parent"
                style="overflow-y: auto; overflow-x: hidden; cursor: pointer;"
                :class="selected ? 'selected-item' : 'hover-item'"
        >
<!--Check Box-->
            <div class="pr-1" v-if="loading || showCheckBoxes">

                <v-progress-circular
                        v-if="loading"
                        :size="20"
                        :width="2"
                        color="grey"
                        indeterminate
                />

                <template v-else>
                    <v-btn
                            v-if="showCheckBoxes"
                            style="width: 32px; height: 32px"
                            variant="text"
                            small
                            :color="selected ? 'primary lighten-1' : 'grey'"
                            icon
                            @click="$emit('selection', !selected)"
                    >
                        <v-icon>{{ selected ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                    </v-btn>
                </template>
            </div>
<!--Main Text-->
            <div
                    class="pr-2 flex-grow-1"
                    @click="$emit(showCheckBoxes ? 'select' : 'selection', !selected)"
            >
                <slot name="headline">
                    <div :class="subLine ? 'py-1' : 'py-2'" style="overflow-y: auto; overflow-x: hidden">
                        <div
                                v-if="headerLine || $slots.headline"
                                class="text-truncate"
                        >
                            <template v-if="!$slots.headline">
                                {{headerLine || null}}
                            </template>
                        </div>
                        <div v-if="subLine" class="text-truncate text-caption greyType--text pt-1" style="line-height: 1">
                            {{Array.isArray(subLine) ? subLine.join(', ') : subLine}}
                        </div>
                    </div>
                </slot>

            </div>

            <slot name="action"></slot>

        </div>
    </div>
</template>

<script>
    import {blankString} from "@/core/codeFunctions";

    export default {
        props: {
            line1: String,
            line2: String,
            actionButtons: Array,
            showCB: Boolean,
            item: Object,
            loading: Boolean,
            selected: Boolean,
            showCheckBoxes: Boolean,
        },
        computed: {
            headerLine() {
                return blankString(this.item[this.line1]) ? null : this.item[this.line1];
            },
            subLine() {
                return blankString(this.item[this.line2]) ? null : this.item[this.line2];
            }
        }
    }
</script>

<style scoped>

</style>
